<template>
    <b-modal
        id="modal-catalog-product-variant-edit"
        ref="modal"
        :title="$t('edit')"
        size="lg"
        centered
        footer-class="justify-content-start"
        no-close-on-esc
        no-close-on-backdrop
        ok-only
        cancel-variant="light"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
        :ok-title="$t('save')"
        :ok-disabled="submitting"
        :hide-header-close="submitting"
        @hidden="handleHidden()"
        @ok="handleOk"
        @show="initForm()"
    >
        <b-overlay :show="submitting" class="h-100">
            <form v-if="variant" @submit.prevent>
                <FormValidator :validator="$v.form.code" form-group v-slot="slotProps" :label="$t('code')">
                    <b-form-input v-model="form.code" :placeholder="$t('code')" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.url" form-group v-slot="slotProps" :label="$t('url')">
                    <b-form-input v-model="form.url" :placeholder="$t('url')" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.description" form-group v-slot="slotProps" :label="$t('description')">
                    <b-form-textarea v-model="form.description" :placeholder="$t('description')" :state="slotProps.state" :disabled="submitting" />
                </FormValidator>
                <FormValidator :validator="$v.form.product" form-group v-slot="slotProps" :label="$t('product')">
                    <Multiselect
                        :initial-value="variant && variant.product"
                        :fetch-options-function="fetchProducts"
                        :placeholder="$t('selectField.placeholder')"
                        asynchronous
                        searchable
                        show-selected
                        track-by="id"
                        label="name"
                        select-label=""
                        :disabled="submitting"
                        :state="slotProps.state"
                        @changeTrackBy="form.product = $event"
                    />
                </FormValidator>
                <FormValidator :validator="$v.form.manufacturer" form-group v-slot="slotProps" :label="$t('manufacturer')">
                    <Multiselect
                        :initial-value="variant && variant.manufacturer"
                        :fetch-options-function="fetchManufacturers"
                        :placeholder="$t('selectField.placeholder')"
                        asynchronous
                        searchable
                        show-selected
                        track-by="id"
                        label="name"
                        select-label=""
                        :disabled="submitting"
                        :state="slotProps.state"
                        @changeTrackBy="form.manufacturer = $event"
                    />
                </FormValidator>
            </form>
        </b-overlay>
    </b-modal>
</template>



<script>
    import { required } from 'vuelidate/lib/validators';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';
    import { deepMergeWithFilter } from '@/utils/util';
    import FormValidator from '@/components/common/FormValidator.vue';
    import Multiselect from '@/components/common/Multiselect.vue';
    import cloneDeep from 'lodash/cloneDeep';

    const FORM_DEFAULT_DATA = Object.freeze({
        spec: null,
        code: '',
        url: '',
        description: '',
        product: null,
        manufacturer: null,
    });

    export default {
        name: 'ModalEdit',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
            Multiselect,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestVariants: this.$req('catalog/variants'),
                requestProducts: this.$req('catalog/products'),
                requestManufacturers: this.$req('catalog/manufacturers'),
                form: cloneDeep(FORM_DEFAULT_DATA),
                formValidations: {
                    form: {
                        spec: { required },
                        code: { required },
                        url: { required },
                        description: { required },
                        product: { required },
                        manufacturer: { required },
                    },
                },
            };
        },
        computed: {
            variant() {
                return this.parentComponent.variant;
            },
            submitting() {
                return this.requestVariants.getLoading();
            },
        },
        methods: {
            initForm() {
                this.form = deepMergeWithFilter(this.form, this.variant);
                this.form.product = this.variant.product?.id || null;
                this.form.manufacturer = this.variant.manufacturer?.id || null;
            },
            handleOk(bvModalEvent) {
                bvModalEvent.preventDefault();
                this.requestVariants
                    .patch({ urlParams: { id: this.parentComponent.id }, requestParams: this.form })
                    .then(data => {
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.$refs.modal.hide();
                        this.parentComponent.fetchVariant();
                    })
                    .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
            handleHidden() {
                this.form = cloneDeep(FORM_DEFAULT_DATA);
            },
            fetchProducts({ search }) {
                const requestParams = {
                    sort: 'name',
                    order: 'ASC',
                    page: 1,
                    perPage: Number.MAX_SAFE_INTEGER,
                    name: search,
                };
                return this.requestProducts.get({ requestParams }).then(data => data?.items || []);
            },
            fetchManufacturers({ search }) {
                const requestParams = {
                    sort: 'name',
                    order: 'ASC',
                    page: 1,
                    perPage: Number.MAX_SAFE_INTEGER,
                    name: search,
                };
                return this.requestManufacturers.get({ requestParams }).then(data => data?.items || []);
            },
        },
    };
</script>
